import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create Payscale
export const createPayscale = createAsyncThunk(
  'payscale/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/payscale', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create payscale');
    }
  }
);

// Fetch All Payscales
export const fetchPayscales = createAsyncThunk(
  'payscale/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/payscale');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch payscales');
    }
  }
);

// Fetch Payscale by ID
export const fetchPayscaleById = createAsyncThunk(
  'payscale/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/payscale/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch payscale');
    }
  }
);

// Update Payscale
export const updatePayscale = createAsyncThunk(
  'payscale/update',
  async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/payscale/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update payscale');
    }
  }
);

// Delete Payscale
export const deletePayscale = createAsyncThunk(
  'payscale/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/payscale/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete payscale');
    }
  }
);
